import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { Reveal, Overline } from "@/components/primitives";

const VIDEO_URL =
  "https://customer-assets-jai6qajn.emergentagent.net/job_smartweb-preview/artifacts/t70es7vr_Captions_D005BB.MP4";
const POSTER_URL =
  "https://static.prod-images.emergentagent.com/jobs/9a9a624e-4fd1-49cd-b482-d9d05d1d620b/images/310bd8dd8897dd5c110a1f0eac23305d0665c3d5d3ca1084427709eee865e53d.jpeg";

export default function VideoShowcase() {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const start = () => {
    const v = videoRef.current;
    if (!v) return;
    v.play();
    setPlaying(true);
  };

  return (
    <section className="relative overflow-hidden bg-black py-24 text-white lg:py-32">
      <div className="pointer-events-none absolute inset-0 bg-grid-dark opacity-50" />
      <div className="relative mx-auto max-w-[1280px] px-5 sm:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <Reveal className="flex justify-center"><Overline dark>See it in action</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 text-4xl font-black leading-[1.02] tracking-tighter sm:text-5xl lg:text-6xl">
              Watch SmartWeb work
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mx-auto mt-6 max-w-xl text-lg font-light leading-relaxed text-white/55">
              A quick look at how reviews, replies, and visibility come together — automatically.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.05}>
          <div className="relative mx-auto mt-14 aspect-video w-full max-w-[960px] overflow-hidden rounded-[10px] border border-white/12 bg-black shadow-[0_40px_120px_-40px_rgba(0,0,0,0.9)]">
            <video
              ref={videoRef}
              data-testid="showcase-video"
              className="h-full w-full object-cover"
              src={VIDEO_URL}
              poster={POSTER_URL}
              controls={playing}
              playsInline
              preload="metadata"
              onPlay={() => setPlaying(true)}
              onPause={() => {}}
            />

            {!playing && (
              <button
                data-testid="video-play-button"
                onClick={start}
                aria-label="Play video"
                className="group absolute inset-0 flex items-center justify-center bg-black/40 backdrop-blur-[2px] transition-colors hover:bg-black/30"
              >
                <motion.span
                  whileHover={{ scale: 1.08 }}
                  whileTap={{ scale: 0.96 }}
                  className="flex h-16 w-16 items-center justify-center rounded-full bg-white text-black shadow-xl"
                >
                  <Play size={22} className="ml-0.5 fill-black" />
                </motion.span>
              </button>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
